var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01849 2C5.54257 2 3.53041 3.91346 3.53041 6.26793V8.32365C3.53041 8.75756 3.33593 9.41909 3.10404 9.78897L2.24383 11.1476C1.71274 11.987 2.07926 12.9188 3.05168 13.2318C6.27562 14.2561 9.75389 14.2561 12.9778 13.2318C13.8829 12.9472 14.2794 11.9301 13.7857 11.1476L12.9255 9.78897C12.7011 9.41909 12.5066 8.75756 12.5066 8.32365V6.26793C12.5066 3.92057 10.4869 2 8.01849 2Z",
    stroke: "#344868",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C8.83243 1.92857 8.65946 1.87302 8.48108 1.84127C7.96216 1.74603 7.46486 1.80159 7 2C7.15676 1.4127 7.54595 1 8 1C8.45405 1 8.84324 1.4127 9 2Z",
    stroke: "#344868",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C10 15.1 9.1 16 8 16C7.45333 16 6.94667 15.7733 6.58667 15.4133C6.22667 15.0533 6 14.5467 6 14",
    stroke: "#344868",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c2a8f2194873f1c47dc92339a6742f9d.svg";
export { ForwardRef as ReactComponent };